import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { MessagePlugin } from 'tdesign-react';

import { StoryNumberListData } from '@/pages/numberSystem/setNumberTable/table';
import { CgiErrorCode } from '@/services/cgi';
import { getStoryNumberList } from '@/services/storyNumber';


export interface StoryNumberSToreState {
  loading: boolean,
  list: StoryNumberListData[]
}

const initialState: StoryNumberSToreState = {
  loading: false,
  list: [],
};

export const getStoryNumberListStore = createAsyncThunk('storyNumber/list', getStoryNumberList);

export const storyNumber = createSlice({
  name: 'basic',
  initialState,
  reducers: {
    initStoryNumberList() {
      return {
        loading: false,
        list: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStoryNumberListStore.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStoryNumberListStore.fulfilled, (state, { payload }) => {
      const { code, data, message } = payload;
      if (code === CgiErrorCode.NO_ERROR) {
        return {
          ...state,
          loading: false,
          list: data?.list || [],
        };
      }
      MessagePlugin.error(message || '获取属性列表失败');
      return {
        ...state,
        loading: false,
      };
    });
  },
});

export const { initStoryNumberList } = storyNumber.actions;

export default storyNumber.reducer;
